import { render, staticRenderFns } from "./BalanceDepositAccount.vue?vue&type=template&id=fc68ba14&scoped=true&"
import script from "./BalanceDepositAccount.vue?vue&type=script&lang=js&"
export * from "./BalanceDepositAccount.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDepositAccount.vue?vue&type=style&index=0&id=fc68ba14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc68ba14",
  null
  
)

export default component.exports